// Concrete file, not the '@constants' barrel — see path.js for why.
import { StorageKeys as SK } from '@constants/storage';
import { StorageUtility } from './storage';
import { isEupRoute } from './path';

// sessionStorage.eupReference — the signed-in portal's own preferences, kept
// as one extendable object ({ locale, ... }). Both helpers are no-ops outside
// an EUP route, so a public consent / privacy / cookie / assessment link can
// neither read a dashboard preference nor write one back into it.
export const readEupReference = () => {
  let reference = {};
  if (isEupRoute()) {
    const stored = StorageUtility.getItem(SK.EUP_REFERENCE);
    if (stored && typeof stored === 'object') reference = stored;
  }
  return reference;
};

export const writeEupReference = (patch) => {
  if (isEupRoute()) {
    StorageUtility.setItem(SK.EUP_REFERENCE, { ...readEupReference(), ...patch });
  }
};
